import { useFlagStatus } from '@/lib/use-flag-status';
import { CLAIRE_DESIGNER_FLAG } from '@borradh-workspace/contracts';

export function useClaireDesigner() {
  return useFlagStatus(CLAIRE_DESIGNER_FLAG);
}
